import React from "react";
import { Tiny } from "@ant-design/plots/es/components";

const ProgressChartMini = (props:any) => {

    const percent = props.percent;
    const config = {
        percent,
        width: 180,
        height: 180,
        radius: 1,
        innerRadius: 0.9,
        color: ['#000000', '#FFA800'],
        annotations: [
            {
                type: 'text',
                style: {
                    text: `$${props.price}`,
                    x: '50%',
                    y: '45%',
                    textAlign: 'center',
                    fontSize: 34,
                    lineHeight: 45,
                    fontStyle: 'bold',
                    fill: "#FFFFFF",
                },
            },
            {
                type: 'text',
                style: {
                    text: `Total: $ ${props.totalPrice}`,
                    x: '50%',
                    y: '60%',
                    textAlign: 'center',
                    fontSize: 14,
                    lineHeight: 22,
                    fontStyle: 'normal',
                    fill: "#FFFFFF",
                },
            },
        ],
    };

    return <Tiny.Ring {...config} />;
};

export default ProgressChartMini